/* eslint-disable prefer-destructuring */
import { toSlug } from '@/utils/common';
import { pr } from '@/utils/pxToRem';
import { Stack, Link } from '@mui/material';
import React from 'react';
import AIRPORT_VN from '@/mappings/airport_vn.json';
import { genLinkSeo } from '@/utils/genLinkSeo';

interface SectionFamousToRouteProps {
  toPoint: any;
}

const SectionFamousToRoute: React.FC<SectionFamousToRouteProps> = ({
  toPoint,
}) => {
  const key = toPoint?.airports[0]?.airportCode;
  const listRoute = (AIRPORT_VN as any).routes[key];
  if (listRoute?.length > 10) {
    listRoute.length = 10;
  }
  return (
    <Stack
      spacing="16px"
      marginTop={pr`16px`}
    >
      {listRoute?.map((airpotCode: string) => {
        const areaData = AIRPORT_VN.airports.find((item) => item.AirportCode === airpotCode);
        return (
          <Link
            sx={{ fontWeight: 500 }}
            href={genLinkSeo({
              startName: toPoint?.location,
              startId: toPoint?.id,
              startStateName: toPoint?.stateName,
              endName: areaData?.CityName_Vi,
              endId: +(areaData?.VxrAreaParentId || 0),
              endStateName: areaData?.stateName,
            })}
            key={airpotCode}
          >
            {` Vé máy bay giá rẻ từ
            ${toPoint.location}
            đi 
            ${areaData?.CityName_Vi}
            `}
          </Link>
        );
      })}
    </Stack>
  );
};

export default SectionFamousToRoute;
